import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import { ChangeEvent, useState } from 'react';

import { FieldMetaData } from './types';

type SelectEmailTFCProps = Omit<SelectProps, 'value' | 'onChange'> & {
  onChange: (value: boolean, fieldMetaData: FieldMetaData) => void;
  initialValue?: boolean;
};

export default function SelectEmailTFC({
  onChange,
  label,
  initialValue,
  ...props
}: SelectEmailTFCProps) {
  const [value, setValue] = useState(
    initialValue === true ? 'yes' : initialValue === false ? 'no' : ''
  );

  function handleOnChange(
    event: ChangeEvent<HTMLInputElement> | (Event & { target: { value: unknown; name: string } })
  ): void {
    const newValue = event.target.value as string;
    setValue(newValue);

    const state = newValue ? 'valid' : 'empty';

    onChange(newValue === 'yes', { state, error: null });
  }

  return (
    <FormControl fullWidth>
      <InputLabel id={`label-${label}`} color="secondary">
        {label}{' '}
      </InputLabel>
      <Select
        labelId={`label-${label}`}
        label={label}
        value={value}
        onChange={handleOnChange}
        {...props}
        color="secondary"
      >
        <MenuItem value={''}>&nbsp;</MenuItem>
        <MenuItem value={'yes'}>Yes</MenuItem>
        <MenuItem value={'no'}>No</MenuItem>
      </Select>
    </FormControl>
  );
}
